import { render, staticRenderFns } from "./HotCommonSoftware.vue?vue&type=template&id=aa1e8cfa&scoped=true&"
import script from "./HotCommonSoftware.vue?vue&type=script&lang=js&"
export * from "./HotCommonSoftware.vue?vue&type=script&lang=js&"
import style0 from "./HotCommonSoftware.vue?vue&type=style&index=0&id=aa1e8cfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1e8cfa",
  null
  
)

export default component.exports